<template v-if="isMobile">
  <button class="burger" ref="burger" :class="{ '-close': menuOpen, '-drag': burger.drag }" @touchstart="dragBurger" @click="dragBurger" :aria-expanded="menuOpen ? 'true' : 'false'" aria-controls="header-site" :aria-label="menuOpen ? $t('Close menu') : $t('Open menu')" type="button">
    <span class="burger-line"></span>
    <span class="burger-line"></span>
    <span class="burger-line"></span>
  </button>
</template>

<script>
import { ReadyHook } from 'vue-asyncready'

export default {
  name: 'Burger',
  mixins: [ReadyHook],
  data () {
    return {
      burger: {
        drag: false,
        pos1: 0,
        pos2: 0,
        pos3: 0,
        pos4: 0,
        posInitX: 0,
        posInitY: 0,
        touchTimer: 0
      }
    }
  },
  computed: {
    menuOpen () {
      return this.$store.state['zenith-ui'].menu.open
    }
  },
  methods: {
    dragBurger (e) {
      e.preventDefault()
      this.burger.touchTimer = Date.now()
      if (e.type === 'touchstart') {
        this.burger.posInitX = this.burger.pos3 = e.targetTouches[0].clientX
        this.burger.posInitY = this.burger.pos4 = e.targetTouches[0].clientY
        document.ontouchmove = this.elMove
        document.ontouchend = this.closeDragElement
        this.burger.drag = true
      } else {
        this.headerEvent()
      }
    },
    elMove (e) {
      e.preventDefault()
      // calculate the new cursor position:
      this.burger.pos1 = this.burger.pos3 - e.targetTouches[0].clientX
      this.burger.pos2 = this.burger.pos4 - e.targetTouches[0].clientY
      this.burger.pos3 = e.targetTouches[0].clientX
      this.burger.pos4 = e.targetTouches[0].clientY
      // set the element's new position:
      this.$el.style.left = (this.$el.offsetLeft - this.burger.pos1) + 'px'
      this.$el.style.top = (this.$el.offsetTop - this.burger.pos2) + 'px'
    },
    closeDragElement () {
      if ((Date.now() - this.burger.touchTimer <= 300) && Math.abs(this.burger.pos3 - this.burger.posInitX) <= 5 && Math.abs(this.burger.pos4 - this.burger.posInitY) <= 5) {
        this.headerEvent()
      }
      document.ontouchend = null
      document.ontouchmove = null
      this.burger.touchTimer = 0
      this.burger.drag = false
    },
    headerEvent () {
      this.$store.dispatch('zenith-ui/closeSearch')
      this.$store.dispatch('zenith-ui/toggleMenu')
      this.$el.focus()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~theme/css/core";

.burger {
  display: none;
  z-index: 101;
  width: 1.8rem;
  height: 100%;
  cursor: move;
  background: transparent;
  border: unset;
  transition: transform 0.2s ease-in-out;
  position: relative;
  outline: none;
  padding: 0;

  @include bp(max md) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 0.6rem;
    transition: 0.2s ease-in-out;
  }

  .burger-line {
    display: block;
    width: 100%;
    height: .1rem;
    background: var(--_zenith-header-text-link);
    transition: transform 0.2s 0.2s ease-in-out;
    border-radius: 0.4rem;

    &:nth-child(1){
      width: calc(100% - 0.4rem);
    }

    &:nth-child(2) {
      opacity: 1;
      transition: all 0.2s ease-in-out;
    }

    &:nth-child(3) {
      width: calc(100% - 0.86rem);
    }
  }

  &.-drag {
    transform: scale(1.5);
    transition: transform 0.2s 0.1s ease-in-out;
  }

  &.-close {
    gap: 0;
    height: 2.4rem;

    .burger-line {
      transition: transform 0.2s 0.2s ease-in-out;
      width: 100%;
      border-radius: 0.4rem;

      &:nth-child(1) {
        transform: rotate(45deg);
      }
      &:nth-child(2) {
        opacity: 0;
        max-width: 0;
        height: 0;
      }
      &:nth-child(3) {
        margin-top: -0.1rem;
        transform: rotate(-45deg);
      }
    }
  }
}
</style>
